module.exports = __webpack_public_path__ + "hashed/efba83211ff5cfa40ad4ac9eaefbeed9.svg";